module.exports = __webpack_public_path__ + "img/selected4-min.356f6227.png";